import CircularProgress from "@material-ui/core/CircularProgress";
import React from "react";

const Loading = ({ label }) => {
  return (
    <div className="loadingPage" role="status" aria-live="polite" aria-busy="true">
      <CircularProgress />
      {label && <span className="loadingPageLabel">{label}</span>}
    </div>
  );
};
export default Loading;
